import { type FC } from 'react';
import { styled } from 'styled-components';

import { useGoodCannaStatus } from 'src/utils/hooks/use-good-canna-status';

type MedCertSelectCartPillProps = {
  goodCannaStatus?: number | null;
};

/**
 * Status pill on cart list rows (curbside / delivery) when med certification is pending or denied.
 */
export const MedCertSelectCartPill: FC<MedCertSelectCartPillProps> = ({ goodCannaStatus }) => {
  const { medSelectCartPillLabel } = useGoodCannaStatus(goodCannaStatus);

  if (!medSelectCartPillLabel) {
    return null;
  }

  return (
    <Pill $variant={medSelectCartPillLabel === 'Med denied' ? 'denied' : 'pending'} data-testid='med-cert-cart-pill'>
      {medSelectCartPillLabel}
    </Pill>
  );
};

const Pill = styled.span<{ $variant: 'denied' | 'pending' }>`
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 600;
  flex-shrink: 0;
  padding: 0.25rem 0.6rem;
  border-radius: 0.875rem;
  border: 1px solid
    ${({ $variant }) => ($variant === 'denied' ? '#fecaca' : '#e8d4c4')};
  background: ${({ $variant }) => ($variant === 'denied' ? '#fef2f2' : '#fff8f0')};
  color: ${({ $variant }) => ($variant === 'denied' ? '#991b1b' : 'var(--color-gray-90)')};
`;
